export function getValidMinPrice(product) {
  const variants = product.variants.edges;
  const filteredVariants = variants.filter((variant) => !variant.node.title.includes("48"));

  if (filteredVariants.length === variants.length) {
    return parseFloat(product.priceRange.minVariantPrice.amount);
  }

  const prices = filteredVariants
    .map((variant) => parseFloat(variant.node.price.amount))
    .sort((a, b) => a - b);

  return prices.length > 0 ? prices[0] : null;
}
